import { Fab, Zoom } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import { AI_CHAT_GRADIENT, AI_CHAT_GRADIENT_HOVER } from './theme';

interface AiChatBubbleProps {
  open: boolean;
  onToggle: () => void;
}

// Burbuja flotante fija, visible en toda la app (ver plan del modulo:
// "widget flotante, app-wide, no una pantalla dedicada"). Se monta una sola
// vez en Layout.tsx, junto a UserDialog/ChangePasswordDialog.
export default function AiChatBubble({ open, onToggle }: AiChatBubbleProps) {
  return (
    <Zoom in>
      <Fab
        onClick={onToggle}
        aria-label={open ? 'Cerrar chat de datos' : 'Abrir chat de datos'}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: (theme) => theme.zIndex.modal + 1,
          background: AI_CHAT_GRADIENT,
          color: '#fff',
          '&:hover': { background: AI_CHAT_GRADIENT_HOVER },
        }}
      >
        {open ? <CloseIcon /> : <AutoAwesomeIcon />}
      </Fab>
    </Zoom>
  );
}
